import React from 'react';
import dynamic from 'next/dynamic';
import { getValidVideoId, getVideoTypeFromUrl } from '../utils';
import { YoutubeVideo } from './youtube/YoutubeVideo';
import { PlaceholderVideo } from './PlaceholderVideo';

interface VideoDataHandlerProps {
  videoUrl: string | undefined;
  shouldShowPreview: boolean;
  readonly: boolean;
}

// avoid SSR for VimeoVideo
// because it uses a third-party library (vimeo-player) that is not compatible with SSR
const VimeoVideo = dynamic(
  () => import('./vimeo/VimeoVideo').then((C) => C.VimeoVideo),
  { ssr: false },
);

export const VideoDataHandler = ({
  videoUrl,
  shouldShowPreview,
  readonly,
}: VideoDataHandlerProps) => {
  if (!videoUrl) return <PlaceholderVideo />;

  const videoType = getVideoTypeFromUrl(videoUrl);
  const videoId = getValidVideoId(videoUrl);

  if (videoType === 'youtube') {
    return (
      <YoutubeVideo
        src={videoUrl}
        shouldShowPreview={shouldShowPreview}
        readonly={readonly}
      />
    );
  }

  if (videoType === 'vimeo' && typeof videoId === 'number') {
    return (
      <VimeoVideo
        videoUrl={videoUrl}
        videoId={videoId}
        shouldShowOverlay={!shouldShowPreview}
        readonly={readonly}
      />
    );
  }

  return <PlaceholderVideo />;
};
